export const TagBadges = ({ tags = [], testid }) => (
  <div data-testid={testid} className="flex min-w-0 flex-wrap gap-1">
    {tags.length ? tags.map((name, i) => <span key={name} data-testid={`${testid}-${i}`} className="max-w-full break-words rounded-sm border border-cyan-200 bg-cyan-50 px-1.5 py-0.5 text-xs font-normal text-cyan-900 [overflow-wrap:anywhere]">{name}</span>) : <span className="text-xs font-normal text-zinc-400">—</span>}
  </div>
);

export const matchesTags = (item, selected) => !selected.length || (item.tags || []).some(tag => selected.some(name => name.toLowerCase() === tag.toLowerCase()));